import clsx from "clsx";
import { SignUpForm } from "../../../../platform/views/Auth/SignUp";
import Clearco from "../../assets/logos/Clearco.svg";
import Openly from "../../assets/logos/Openly.svg";
import Farmers from "../../assets/logos/Farmers.svg";
import StandardChartered from "../../assets/logos/StandardChartered.svg";
import Anz from "../../assets/logos/Anz.svg";
import { LandingCtas } from "./LandingCtas";
import { LandingContactForm } from "./LandingContactForm";

export const LandingHero = ({ data }) => {
  return (
    <section
      className={clsx(
        "LandingHero-background",
        data.background_color && `LandingHero-background-${data.background_color}`,
        data.background_gradient && `LandingHero-background-gradient`,
      )}
    >
      <div
        className={clsx(
          "LandingHero",
          data.type && `LandingHero-type-${data.type}`,
          data.background_color && `LandingHero-${data.background_color}`,
          data.align && `LandingHero-align-${data.align}`,
        )}
        id="hero"
      >
        <section className="section-layout">
          {data.headline && <h1 className="LandingHero-title">{data.headline}</h1>}
          {data.subheadline && <p className="LandingHero-subtitle">{data.subheadline}</p>}
          {data.show_image && (
            <img
              className="LandingHero-image"
              src={data.image}
              alt={data.image_alt}
              loading="eager"
            />
          )}
          {data.type === "cta" && <LandingCtas ctas={data?.ctas} />}
          {data.show_logos && (
            <div className="LandingHero-logos">
              {data.logos_headline && <p>{data.logos_headline}</p>}
              <div className="LandingHero-logos-images">
                <img
                  src={Farmers.src}
                  alt="Farmers Insurance"
                  loading="eager"
                  width="82"
                  height="44"
                />
                <img src={Anz.src} alt="ANZ" loading="eager" width="96" height="31" />
                <img
                  src={StandardChartered.src}
                  alt="Standard Chartered"
                  loading="eager"
                  width="111"
                  height="45"
                />
                <img src={Openly.src} alt="Openly" loading="eager" width="71" height="45" />
                <img
                  src={Clearco.src}
                  alt="Clearco (formerly Clearbank)"
                  loading="eager"
                  width="119"
                  height="25"
                />
              </div>
            </div>
          )}
        </section>
        {data.type === "platform-sign-up" && (
          <section className="section-layout">
            <SignUpForm
              className="LandingHero-form"
              showLogInLink={false}
              titleOverride={data.form_title}
              sentTitleOverride={data.form_sent_title}
              sentMessageOverride={data.form_sent_message}
            />
          </section>
        )}
        {data.type === "contact-form" && (
          <section className="section-layout">
            <LandingContactForm data={data} />
          </section>
        )}
      </div>
    </section>
  );
};
